module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('main', {
    staticClass: "content"
  }, [_vm._m(0), _vm._v(" "), _c('form', {
    staticClass: "form",
    attrs: {
      "validate": ""
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.addVideo($event)
      }
    }
  }, [(_vm.errorMessage) ? _c('Message', {
    attrs: {
      "message-content": _vm.errorMessage,
      "message-status": "error"
    }
  }) : _vm._e(), _vm._v(" "), _c('fieldset', {
    staticClass: "form--item"
  }, [_c('label', {
    staticClass: "label",
    attrs: {
      "for": ""
    }
  }, [_vm._v("\n                    Featured Video:\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "inputGroup"
  }, [_c('div', {
    staticClass: "inputGroup--state",
    class: {
      'active': _vm.video_type == 'featured'
    },
    on: {
      "click": function($event) {
        _vm.video_type = 'featured'
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "input_text"
  }, [_c('v-select', {
    attrs: {
      "required": "",
      "searchable": false,
      "placeholder": "Click to select a featured video",
      "options": _vm.featured
    },
    model: {
      value: (_vm.contentId),
      callback: function($$v) {
        _vm.contentId = $$v
      },
      expression: "contentId"
    }
  })], 1)])]), _vm._v(" "), _c('fieldset', {
    staticClass: "form--item"
  }, [_c('label', {
    staticClass: "label",
    attrs: {
      "for": ""
    }
  }, [_vm._v("\n                    Youtube or Vimeo Link:\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "inputGroup"
  }, [_c('div', {
    staticClass: "inputGroup--state",
    class: {
      'active': _vm.video_type == '3rdparty'
    },
    on: {
      "click": function($event) {
        _vm.video_type = '3rdparty'
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "input_text"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.link),
      expression: "link"
    }],
    attrs: {
      "name": "",
      "placeholder": "Paste a URL link from a Youtube or Vimeo video under 14’55”",
      "type": "text"
    },
    domProps: {
      "value": (_vm.link)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.link = $event.target.value
      }
    }
  })])])]), _vm._v(" "), _c('fieldset', {
    staticClass: "form--item"
  }, [_c('label', {
    staticClass: "label",
    attrs: {
      "for": ""
    }
  }, [_vm._v("\n                  Wall:\n              ")]), _vm._v(" "), _c('div', {
    staticClass: "input_text",
    attrs: {
      "id": "wallId"
    }
  }, [_c('v-select', {
    attrs: {
      "required": "",
      "searchable": false,
      "placeholder": "Click to select a wall",
      "options": _vm.walls
    },
    model: {
      value: (_vm.wallId),
      callback: function($$v) {
        _vm.wallId = $$v
      },
      expression: "wallId"
    }
  })], 1)]), _vm._v(" "), _c('fieldset', {
    staticClass: "form--item"
  }, [_c('label', {
    staticClass: "label",
    attrs: {
      "for": ""
    }
  }, [_vm._v("\n                  Day:\n              ")]), _vm._v(" "), _c('div', {
    staticClass: "input_text",
    attrs: {
      "id": "starttime_date"
    }
  }, [_c('el-date-picker', {
    attrs: {
      "required": "",
      "type": "date",
      "placeholder": "Click to select a day"
    },
    model: {
      value: (_vm.starttime.date),
      callback: function($$v) {
        _vm.$set(_vm.starttime, "date", $$v)
      },
      expression: "starttime.date"
    }
  })], 1)]), _vm._v(" "), _c('fieldset', {
    staticClass: "form--item"
  }, [_c('label', {
    staticClass: "label",
    attrs: {
      "for": ""
    }
  }, [_vm._v("\n                  Timeslot:\n              ")]), _vm._v(" "), _c('div', {
    staticClass: "input_text",
    attrs: {
      "id": "starttime_time"
    }
  }, [_c('el-time-select', {
    attrs: {
      "picker-options": {
        start: '00:00',
        step: '00:15',
        end: '23:45'
      },
      "placeholder": "Click to select a start timeslot"
    },
    model: {
      value: (_vm.starttime.time),
      callback: function($$v) {
        _vm.$set(_vm.starttime, "time", $$v)
      },
      expression: "starttime.time"
    }
  })], 1)]), _vm._v(" "), _vm._m(1)], 1), _vm._v(" "), _c('loading', {
    attrs: {
      "visible": _vm.loadingVisible
    },
    on: {
      "update:visible": function($event) {
        _vm.loadingVisible = $event
      }
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('h1', [_vm._v("\n              Schedule New Video\n          ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('button', {
    staticClass: "btn btn_blue",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("\n                  Add video\n              ")])])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-2c8ae676", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2c8ae676","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Schedule/AddSchedule.vue
// module id = 431
// module chunks = 1